import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconImac: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconImac"><Path d="M2 3V12.5H22V3H2Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 18V14H22V18H15V22H9V18H2ZM10.5 18V20.5H13.5V18H10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconImac;
